export class ForgotPass {
    UserEmail: any;
}